import { Injectable } from '@angular/core';
import { Cor } from '@tivic-team/manager-ts/dist/fta';
import { CorVeiculoController } from './../../controllers/fta/cor-veiculo.controller';
import { LoaderService } from './../loader.service';
import { CorVeiculoSearch } from './cor-veiculo.search';

@Injectable({
  providedIn: 'root'
})
export class CorVeiculoService {
  
  constructor(private _corVeiculoController: CorVeiculoController, private _loaderService: LoaderService) {}

  find(search?: CorVeiculoSearch): Promise<Cor[]> {
      this._loaderService.show();
      return this._corVeiculoController.find((search && search.getFilters()) || null).finally(() => this._loaderService.hide());
  }

  get(id: number): Promise<Cor> {
      this._loaderService.show();
      return this._corVeiculoController.get(id).finally(() => this._loaderService.hide());
  }
  
  create(entity: Cor): Promise<Cor> {
      this._loaderService.show();
      return this._corVeiculoController.create(entity).finally(() => this._loaderService.hide());
  }
  
  update(entity: Cor): Promise<Cor> {
      this._loaderService.show();
      return this._corVeiculoController.update(entity).finally(() => this._loaderService.hide());
  }

  async save(cor: Cor): Promise<Cor> {
    this._loaderService.show();

    if (cor.cdCor && cor.cdCor > 0) {
      return this._corVeiculoController.update(cor).finally(() => this._loaderService.hide());
  } else {
    return this._corVeiculoController.create(cor).finally(() => this._loaderService.hide());
  }
 }

}
